import { ContentItemInterface } from '@/interfaces/contentItem'
import { StatisticTitle, StatisticDescription } from './Statistics.styles'

const Statistics : React.FC<ContentItemInterface> = (props) => {
  const {
    title,
    description,
  } = props

  return (
    <div>
      {title && <StatisticTitle>{title}</StatisticTitle>}
      {description && <StatisticDescription>{description}</StatisticDescription>}
    </div>
  )
}

export default Statistics
